import axios from "axios";
import Config from "../utils/Config";

class SignatoryRellocationService {

    config = {
        headers: {
            Authorization: "",
            CompanyId: "",
        },
    };

    //set access token
    setAccessToken(accessToken, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.CompanyId = companyId;
    }

    //update email status for leave type
    async updateEmailStatus(updateEmailStatusObj, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);

        const data = await axios.patch(
            Config.BACKEND_URL + "/api/leave/updateEmailStatus",
            updateEmailStatusObj,
            this.config
        )
        return data.data;
    }

    //get all meetings for leave type
    async fetchAllMeetingsForLeaveType(formData, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
       
        const data = await axios.post(
          Config.BACKEND_URL + "/api/leave/meetings",
          formData,
          this.config
        )
        return data.data;
      }

    //assign meetings for leave type
    async assignMeetingsForLeaveType(formData, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
       
        const data = await axios.post(
          Config.BACKEND_URL + "/api/leave/assignMeetings",
          formData,
          this.config
        )
        return data.data;
      }

    //get all meetings for meeting type
    async fetchAllMeetingsForMeetingType(formData, companyId, accessToken) {
      this.setAccessToken(accessToken, companyId);
     
      const data = await axios.post(
        Config.BACKEND_URL + "/api/meetingCoverage/meetings", //api/meetingCoverage/meetings
        formData,
        this.config
      )
      return data.data;
    }

    //assign meetings for meeting type
    async assignMeetingsForMeetingType(formData, companyId, accessToken) {
      this.setAccessToken(accessToken, companyId);
     
      const data = await axios.post(
        Config.BACKEND_URL + "/api/meetingCoverage/assignDeclineMeeting", //api/meetingCoverage/assignDeclineMeeting
        formData,
        this.config
      )
      return data.data;
    }
}

export default new SignatoryRellocationService();